var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 9.5C11.7835 9.5 11 10.2835 11 11.25V28.75C11 29.7165 11.7835 30.5 12.75 30.5H26.75C27.7165 30.5 28.5 29.7165 28.5 28.75V11.25C28.5 10.2835 27.7165 9.5 26.75 9.5H12.75ZM14.5 26.125C14.0167 26.125 13.625 26.5167 13.625 27C13.625 27.4832 14.0167 27.875 14.5 27.875H22.375C22.8582 27.875 23.25 27.4832 23.25 27C23.25 26.5167 22.8582 26.125 22.375 26.125H14.5ZM13.625 23.5C13.625 23.0167 14.0167 22.625 14.5 22.625H25C25.4832 22.625 25.875 23.0167 25.875 23.5C25.875 23.9832 25.4832 24.375 25 24.375H14.5C14.0167 24.375 13.625 23.9832 13.625 23.5ZM21.0675 11.2C22.1396 11.2 23.08 12.0292 23.08 13.1375V17.675C23.08 19.4667 21.552 20.85 19.755 20.85C17.958 20.85 16.43 19.4667 16.43 17.675V14.375C16.43 13.9884 16.7434 13.675 17.13 13.675C17.5166 13.675 17.83 13.9884 17.83 14.375V17.675C17.83 18.6171 18.6525 19.45 19.755 19.45C20.8575 19.45 21.68 18.6171 21.68 17.675V13.1375C21.68 12.8789 21.4452 12.6 21.0675 12.6C20.6899 12.6 20.455 12.8789 20.455 13.1375V17.675C20.455 18.0616 20.1416 18.375 19.755 18.375C19.3684 18.375 19.055 18.0616 19.055 17.675V13.1375C19.055 12.0292 19.9954 11.2 21.0675 11.2Z",
    fill: "#4251DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachOrder);
export default __webpack_public_path__ + "static/media/attach-order.5c4ec9eff326853014c22d87ba9c4cac.svg";
export { ForwardRef as ReactComponent };